module.exports = __webpack_public_path__ + "img/arrow-right.ba330cf9.svg";